/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:586aaa70-2bc8-4ff3-a163-310f21bed769",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_v6UiaTWjV",
    "aws_user_pools_web_client_id": "415oc234vogqvhlhefq5ehft02",
    "oauth": {
        "domain": "csv-uploads.auth.us-east-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "sliuploaderv2165710-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
